import React from 'react'
import { SectionHeader } from '@/components/molecules/SectionHeader'
import { ServiceCard } from '@/components/molecules/ServiceCard'
import './ServicesSection.css'
import researchServiceImage from '@/assets/research_service_image.jpg'
import designServiceImage from '@/assets/design_service_image.jpg'
import buildServiceImage from '@/assets/build_service_image.jpg'

export interface ServicesSectionProps {
  className?: string
  id?: string
}

export interface Service {
  title: string
  description: string
  services: string[]
  imageUrl?: string
  imageAlt?: string
}

const services: Service[] = [
  {
    title: 'Research',
    description:
      'We thrive at the intersection of design and business through our UI UX design services and craft beautiful and functional experiences that can be launched quickly.',
    services: [
      'Heuristic Analysis',
      'Usability Testing',
      'Usability Testing',
      'Design Audit',
      'UX Research',
    ],
    imageUrl: researchServiceImage,
  },
  {
    title: 'Design',
    description:
      'We see design as a collaborative endeavor, requiring inputs from all stakeholders in order to create immersive experience and scalable solutions through our UI UX Design and consulting services.',
    services: [
      'Digital Branding',
      'User Experience Design',
      'User Interface Design',
      'Interaction Design',
      'Motion Graphics',
      'Prototyping',
    ],
    imageUrl: designServiceImage,
  },
  {
    title: 'Build',
    description:
      'We help you translate any kind of design into functional and scalable digital products such as websites, mobile apps, or enterprise platforms/solutions.',
    services: [
      'Front-End',
      'Web Application',
      'Mobile Applications',
      'Custom Application',
    ],
    imageUrl: buildServiceImage,
  },
]

export const ServicesSection: React.FC<ServicesSectionProps> = ({
  className = '',
  id,
}) => {
  return (
    <section id={id} className={`services-section ${className}`}>
      <SectionHeader
        title="Services we offer"
        description="We provide meaningful and actionable data-driven insights that represent the voice of a user"
      />

      <div className="services-section-cards">
        {services.map((service, index) => (
          <ServiceCard
            key={index}
            title={service.title}
            description={service.description}
            services={service.services}
            imageUrl={service.imageUrl}
            imageAlt={service.imageAlt}
            stepNumber={`STEP ${index + 1}`}
          />
        ))}
      </div>
    </section>
  )
}
